
import React, { useState, useEffect } from "react";
import { BiometricsChart } from "./BiometricsChart"
import { updateObject } from "../../../shared/utility"

export default function EndUserChartData({ beneficiaryChartData }) {
    const [data, setData] = useState();

    const xFormat = "time:%d/%m/%Y %H:%M:%S";
    const AxisBottomLegend = "Ημερομηνία Βιομετρικής Ένδειξης";
    const axisBottomFormat = "%d/%m/%Y %H:%M:%S";
    const AxisLeftLegend = 'Τιμή Βιομετρικής Ένδειξης';

    const changeData= (e) => {
        let newData = [...beneficiaryChartData.map((data) => {
            if (data.id !== e.id && e.id !== "'Ολοι οι Τύποι") {
                return updateObject(data, { data: [] })
            }
            return data;
        })]
        setData(newData);
    }

    useEffect(() => {
        setData(beneficiaryChartData);
    }, [beneficiaryChartData])

    return <BiometricsChart data={data} xFormat={xFormat} AxisBottomlegend={AxisBottomLegend} axisBottomFormat={axisBottomFormat} AxisLeftLegend={AxisLeftLegend} changeData= {changeData}/>


}